export default "__VITE_ASSET__Bmx5i084__"